export enum FormType {
  PRIOR_INFORMATION = 'Vorinformation',
  NOTICE = 'Verfahren',
  EXANTE = 'Ex-Ante',
  EXPOST = 'Ex-Post',
  CONTRACT_MODIFICATION = 'Vertragsänderung',
}
